import { formatProductionPath, formatSomHistoryDate } from './somHistoryHelpers';

// What to say instead of a score when the latest check has none. A failed or
// thin check is never rendered as 0%.
export function somStateMessage(production = {}) {
  if (!production.has_data) return 'No production SoM checks yet';
  if (production.measurement_state === 'INSUFFICIENT_EVIDENCE') {
    return 'The latest check had too few usable answers to produce a score';
  }
  if (production.measurement_state === 'UNKNOWN') {
    return 'The latest check could not be completed, so there is no score';
  }
  return 'No score is available for the latest check';
}

export function somProductionKpiView(production = {}, somKpi = {}) {
  const hasData = !!production.has_data;
  const score = somKpi.value;
  const isLive = hasData && typeof score === 'number';
  const latest = production.latest_score;
  const notComparable = production.score_change_comparability === 'DIFFERENT';
  return {
    hasData,
    isLive,
    score,
    measurementState: production.measurement_state || null,
    emptyMessage: isLive ? null : somStateMessage(production),
    scoreLabel: isLive ? `${score}%` : null,
    latestScoreLabel: typeof latest === 'number' ? `${latest}%` : 'No score',
    changeNote: notComparable ? 'Measurement method changed — not comparable with the previous check' : null,
    methodologyLabel: production.methodology_state === 'KNOWN' ? 'Recorded' : 'Not recorded (historical)',
    pathLabel:
      production.latest_execution_path_label
      || formatProductionPath({ execution_path: production.latest_execution_path }),
    coverage: production.prompt_coverage || 'Unavailable',
    mentions: production.mentions_coverage || 'Unavailable',
    lastChecked: formatSomHistoryDate(production.last_checked_at),
    failedPrompts: production.failed_prompts == null ? 'Unavailable' : String(production.failed_prompts),
    showTrend: hasData && Array.isArray(production.score_trend) && production.score_trend.length > 0,
  };
}
